import * as React from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';

import VendorSignup from '../components/vendor-signup';
import { logEvent, AnalyticsEvent } from '@weddingspot/ws-analytics';
import { StorableDataKeys, LocalStorage, WSAppContextType, WSAppContext } from '@weddingspot/ws-core-components';

export default class VendorSignupContainer extends React.Component {
    static contextType: React.Context<WSAppContextType> = WSAppContext;
    context!: React.ContextType<typeof WSAppContext>;

    public render() {
        return (
            <div>
                <Helmet>
                    <title>Venue Signup | Wedding Spot</title>
                </Helmet>
                <VendorSignup
                    showUserSignupModal={() => this.context.openAuthModal('VLP')}
                    shouldShowAbandonModal={this.shouldShowAbandonModal}
                    abandonModalShown={this.abandonModalShown}
                    abandonModalDismiss={this.abandonModalDismissed}
                    abandonFormSuccess={this.abandonModalSuccess}
                    abandonModalAltCta={this.abandonModalAltCta}
                />
            </div>
        );
    }

    private shouldShowAbandonModal() {
        const shown = LocalStorage.getItem(StorableDataKeys.ABANDON_MODAL_SHOWN_LS_KEY);
        return !shown;
    }

    // Abandon modal was shown
    private abandonModalShown() {
        LocalStorage.setItem(StorableDataKeys.ABANDON_MODAL_SHOWN_LS_KEY, true);

        logEvent(AnalyticsEvent.EVTNM_VLP_EXIT_MODAL_SHOWN, {});
    }

    // Abandon modal was explicitly dismissed
    private abandonModalDismissed() {
        logEvent(AnalyticsEvent.EVTNM_VLP_EXIT_MODAL_DISMISSED, {});
    }

    // Abandon modal form was submitted successfully
    private abandonModalSuccess() {
        logEvent(AnalyticsEvent.EVTNM_VLP_EXIT_MODAL_CTA, {});
    }

    // Abandon modal form alternate cta (user signup) was clicked
    private abandonModalAltCta() {
        logEvent(AnalyticsEvent.EVTNM_VLP_EXIT_MODAL_ALT_CTA, {});
    }
}
